import { jsx as _jsx } from "react/jsx-runtime";
import { ViewPaymentRequest } from '@src/components/Employee/PaymentRequests/ViewPaymentRequest';
import { ApproveCard } from '@src/components/Manager/ApproveCard';
export const BudgetApproval = ({ approval }) => {
    return (_jsx(ViewPaymentRequest, { id: approval.workflowableId, title: 'Funding Request', approval: approval, hideDocuments: true, children: _jsx(ApproveCard, { approval: approval }) }));
};
